// eslint-disable-next-line
import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useContext,
  useCallback,
} from "react";

import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import addToCart from "../helpers/addToCart";
import { CiHeart } from "react-icons/ci";
import { RxEyeOpen } from "react-icons/rx";
import { FiShoppingBag } from "react-icons/fi";
import UserContext from "../context/context";
import axios from "axios";
import summaryApi from "../common/Api";
import DiscountCardSwiper from "../components/DiscountCardSwiper/DiscountCardSwiper";
import addToWishlist from "./../helpers/addToWishlist";

const DiscountProducts = ({ category, heading }) => {
  const loadingList = new Array(13).fill(null); // 13 شريحة تحميل مؤقت
  const scrollElement = useRef();
  const [isClicked, setIsClicked] = useState(false);

  const fetchProducts = useCallback(async () => {
    // setLoading(true);
    try {
      const response = await axios.get(summaryApi.getAllProducts.url, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      // setProducts(response?.data?.data);
      return response?.data?.data || [];
    } catch (error) {
      console.error("Failed to fetch products:", error);
    } finally {
      // setLoading(false);
    }
  }, []);

  const { data: products = [], isLoading } = useQuery({
    queryKey: ["users"],
    queryFn: fetchProducts,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 2,
    keepPreviousData: true,
  });

  const { fetchCartCount } = useContext(UserContext);

  const handleAddToCart = async (e, productId) => {
    setIsClicked(true);
    try {
      await addToCart(e, productId);
      fetchCartCount();
    } catch (error) {
      console.error("Error adding product to cart:", error);
    } finally {
      setIsClicked(false);
    }
  };

  const handleAddToWishlist = async (e, productId) => {
    e.preventDefault();
    e.stopPropagation(); // تأكد من استخدام e كحدث
    setIsClicked(true);
    try {
      await addToWishlist(e, productId); // تمرير e هنا
    } catch (error) {
      console.error("Failed to add to wishlist.", error);
    } finally {
      setIsClicked(false);
    }
  };

  useEffect(() => {
    if (scrollElement.current) {
      scrollElement.current.scrollTo({
        left: scrollElement.current.scrollLeft + 150,
        behavior: "smooth",
      });
    }
  }, [products]);

  const filteredProducts = useMemo(() => {
    return products.filter(
      (product) => product?.price - product?.discount > 50
    );
  }, [products]);

  return (
    <div className="container p-4 mx-auto relative">
      <h2 className="text-xl semibold " style={{ fontFamily: "serif" }}>
        {heading}
      </h2>

      <DiscountCardSwiper />

      <div className="flex gap-4 md:gap-6 justify-center items-center flex-wrap transition-all scroll-smooth">
        {isLoading
          ? loadingList.map((product, index) => (
              <div
                key={index}
                className="w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] shadow-md rounded "
              >
                <div className="h-48 items-center min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] p-4 bg-slate-200 animate-pulse "></div>
                <div className="w-full p-4 md:max-w-[320px] bg-white py-2 grid gap-2">
                  <h2 className="font-semibold text-ellipsis line-clamp-1 animate-pulse rounded-full p-2 bg-slate-200"></h2>
                  <p className="text-sm text-gray-500 capitalize my-1 animate-pulse rounded-full p-2 bg-slate-200"></p>
                  <div className="flex gap-3 items-center my-2">
                    <p className="text-red-600 font-bold animate-pulse rounded-full p-2 bg-slate-200 w-full"></p>
                    <p className="text-gray-500 line-through animate-pulse rounded-full p-2 bg-slate-200 w-full "></p>
                  </div>
                  <button className="w-full text-white text-sm font-semibold p-2 rounded-full animate-pulse bg-slate-200"></button>
                </div>
              </div>
            ))
          : filteredProducts?.map((product) => (
              <div key={product._id} className=" rounded-2xl">
                <Link
                  to={`/product/${product._id}`}
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="w-[calc(50%-0.5rem)] md:w-[calc(33.333%-1.25rem)] max-w-[165px] md:max-w-[320px] shadow-md rounded-md overflow-hidden mb-4"
                >
                  {product?.price - product?.discount > 50 && (
                    <>
                      <div className="relative h-48 items-center min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] p-4 bg-slate-200 ">
                        <img
                          src={product?.product_image[0]}
                          alt={product?.name || "Product Image"}
                          className="w-full h-full object-scale-down mix-blend-multiply hover:scale-110 duration-300"
                          loading="lazy"
                          effect="blur"
                        />
                        <div className="absolute top-0 left-1 md:hidden flex flex-col gap-1 items-start my-2">
                          <button
                            disabled={isClicked}
                            onClick={(e) => handleAddToWishlist(e, product._id)}
                            className="  bg-white w-8 h-8 rounded-full flex items-center justify-center hover:bg-[#32e5ff] transition-all hover:animate-pulse hover:text-white"
                          >
                            {" "}
                            <span className="text-xl ">
                              <CiHeart />
                            </span>{" "}
                          </button>
                          <button className=" bg-slate-100 w-8 h-8 rounded-full flex items-center justify-center hover:bg-[#32e5ff] transition-all hover:animate-pulse hover:text-white">
                            {" "}
                            <span className="text-lg ">
                              <RxEyeOpen />
                            </span>{" "}
                          </button>
                        </div>
                        {product?.price > 300 && (
                          <div className="absolute bottom-0 right-1  my-2">
                            <span className="text-white text-sm font-bold bg-main-background px-1 py-1 rounded-es-xl">
                              New
                            </span>
                          </div>
                        )}

                        {product?.price - product?.discount > 50 && (
                          <div className="absolute bottom-0 right-1  my-2">
                            <span className="text-white text-sm font-bold bg-main-background px-1 py-1 rounded-es-xl">
                              {Math.round(
                                ((product?.price - product?.discount) /
                                  product?.price) *
                                  100
                              )}
                              %
                            </span>
                          </div>
                        )}
                      </div>

                      <div className="w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] p-4 bg-white py-2 grid gap-2">
                        <h2 className="font-semibold text-ellipsis line-clamp-1 ">
                          {product?.name}
                        </h2>
                        <p className="text-sm text-gray-500 capitalize my-1">
                          {product?.category}
                        </p>

                        {product?.discount > 0 ? (
                          <div className="flex flex-row gap-3 items-center">
                            {/* <p className="text-[#536ea4] font-bold "> */}
                            <p className="text-[#536ea4] font-bold ">
                              ${product?.discount}
                            </p>
                            <p className="text-gray-500  line-through">
                              ${product?.price}
                            </p>
                          </div>
                        ) : (
                          <p className="text-[#536ea4] font-bold">
                            ${product?.price}
                          </p>
                        )}

                        <div className="flex justify-between items-center">
                          {product?.quantity > 0 ? (
                            <>
                              <button
                                disabled={isClicked}
                                onClick={(e) => handleAddToCart(e, product._id)}
                                className="md:hidden  bg-slate-100 w-full h-10 rounded flex items-center  hover:bg-main-background transition-all hover:animate-pulse hover:text-white hover:font-bold"
                              >
                                {" "}
                                <span className="text-lg flex items-center mx-auto justify-between gap-2">
                                  <p className="text-base text-slate-400 font-bold hover:text-white px-1 transition-all duration-300">
                                    Add To Cart
                                  </p>
                                  <FiShoppingBag />
                                </span>{" "}
                              </button>

                              <div className="hidden md:flex gap-5 items-center mx-auto  justify-center my-2">
                                <button
                                  disabled={isClicked}
                                  onClick={(e) =>
                                    handleAddToWishlist(e, product._id)
                                  }
                                  className="bg-slate-100 w-8 h-8 rounded-full flex items-center justify-center hover:bg-[#32e5ff] transition-all hover:animate-pulse hover:text-white"
                                >
                                  {" "}
                                  <span className="text-xl ">
                                    <CiHeart />
                                  </span>{" "}
                                </button>
                                <button className="bg-slate-100 w-8 h-8 rounded-full flex items-center justify-center hover:bg-[#32e5ff] transition-all hover:animate-pulse hover:text-white">
                                  {" "}
                                  <span className="text-lg ">
                                    <RxEyeOpen />
                                  </span>{" "}
                                </button>
                                <button
                                  disabled={isClicked}
                                  onClick={(e) =>
                                    handleAddToCart(e, product._id)
                                  }
                                  className="bg-slate-100 w-8 h-8 rounded-full flex items-center justify-center hover:bg-[#32e5ff] transition-all hover:animate-pulse hover:text-white"
                                >
                                  {" "}
                                  <span className="text-lg ">
                                    <FiShoppingBag />
                                  </span>{" "}
                                </button>
                              </div>
                            </>
                          ) : (
                            <button
                              disabled
                              className="w-full text-white text-sm mt-1 font-semibold px-3 py-1 rounded-full bg-red-500"
                            >
                              Out of Stock
                            </button>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </Link>
              </div>
            ))}
      </div>
    </div>
  );
};

export default DiscountProducts;
